let languageCode = 'en';
export const controller = {
    getLanguage() {
        return languageCode;
    },
    setLanguage(code: string) {
        languageCode = code;
    },
};
